// extracted by mini-css-extract-plugin
export default {"panelWrapper":"_3K33s_Gx","center":"_37YPj7pO","withCover":"oyc0ax36","left":"_2xBXW-5Y","right":"_1s39tJ33","logoBox":"Pv0HGYa3","content":"_26HQ620r"};